export const SUPPORT_CONFIG = Object.freeze({
  brandName: "Digital Indian Market Support",
  whatsappNumber: process.env.REACT_APP_SUPPORT_WHATSAPP || "919876543210",
  email: process.env.REACT_APP_SUPPORT_EMAIL || "support@example.com",
});

export function buildVendorSupportLinks({ vendor, role }) {
  const context = `${vendor?.name || "Business"} (${vendor?.id || "unknown"}), role: ${role || "vendor"}`;
  const message = `Hi ${SUPPORT_CONFIG.brandName}, I need help with ${context}.`;
  return {
    whatsapp: `https://wa.me/${SUPPORT_CONFIG.whatsappNumber.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`,
    email: `mailto:${SUPPORT_CONFIG.email}?subject=${encodeURIComponent(`Support request — ${vendor?.name || vendor?.id || "Business"}`)}&body=${encodeURIComponent(message)}`,
  };
}
